<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                            Search Form
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            class="px-2"
                                            v-model="supplier_type_id.value.value"
                                            :error-messages="supplier_type_id.errorMessage.value"
                                            clearable
                                            :items="getSupplierTypeList"
                                            :item-title="(item) => `${item.code} - ${item.name}`"
                                            autocomplete="off"
                                            item-value="id"
                                            >
                                            <template #label>
                                                Supplier Type
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col md="2" cols="12">
                                            <v-btn
                                            class="bg-brand w-100"
                                            type="submit"
                                            ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>           
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                            Supplier List Report
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="6">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="6">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>
                                            </v-btn-group>
                                    </v-col>
                                </v-row>
                                
                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        {{ item.status === 1 ? 'Active':'Inactive' }}
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", key: "index", align: "center",width: "5%", sortable: false },
            { title: "Code", key: "code", align: "left", sortable: false, width: "150px" },
            { title: "Supplier Name", key: "supplier_name", align: "left", sortable: false, width: "200px" },
            { title: "Supplier Type", key: "s_type", align: "center", sortable: false, width: "180px" },
            { title: "Country", key: "s_country", align: "center", sortable: false, width: "100px" },
            { title: "TIN", key: "supplier_tin", align: "center", sortable: false, width: "100px" },
            { title: "BIN", key: "supplier_bin", align: "center", sortable: false, width: "100px" },
            { title: "VAT", key: "supplier_vat", align: "center", sortable: false, width: "100px" },
            { title: "Address", key: "supplier_address", align: "center", sortable: false, width: "100px" },
            { title: "Email", key: "supplier_email", align: "center", sortable: false, width: "100px" },
            { title: "Mobile", key: "supplier_mobile", align: "center", sortable: false, width: "150px" },
            { title: "Status", key: "status", align: "center", sortable: false, width: "120px" },
        ],
    }),
    created() {
        /* if (this.$store.getters.getPurSupplierListReport.length == 0) {
            this.$store.dispatch("getPurSupplierListReport");
        } */
        if (this.$store.getters.getSupplierTypeList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getSupplierTypeList").then((response) => {
                this.loading = false;
            });
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getPurSupplierListReport;
        },
        getSupplierTypeList() {
            let data = this.$store.getters.getSupplierTypeList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        /* flattenedData() {
            return this.getSchema.map((item, index) => ({
                index: index + 1,
                code: item.code,
                supplier_name: item.supplier_name,
                s_type: item.s_type,
                s_country: item.s_country,
                supplier_email: item.supplier_email,
                supplier_mobile: item.supplier_mobile,
                status: item.status
            }));
        } */
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const supplier_type_id = useField("supplier_type_id");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            store
                .dispatch("getPurSupplierListReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            supplier_type_id,
            submit,
            loading,
        };
    },
    methods: {
        exportToPDF() {
            const columns = [
                "#SL",
                "Code",
                "Supplier Name",
                "Supplier Type",
                "Country",
                "Address",
                "Email",
                "Mobile",
                "Status",
            ];
            const rows = this.getSchema.map(item => [
                item.index,
                item.code,
                item.supplier_name,
                item.s_type,
                item.s_country,
                item.supplier_address,
                item.supplier_email,
                item.supplier_mobile,
                item.status == 1 ? "Active" : "Inactive",
            ]);
            this.$exportTableToPDF(columns, rows, "Supplier List Report", "supplier_list_report_" + this.$fileDate());
        },

        exportToExcel() {
            var data = [
                [
                    "#SL",
                    "Code",
                    "Supplier Name",
                    "Supplier Type",
                    "Country",
                    "TIN",
                    "BIN",
                    "VAT",
                    "Address",
                    "Email",
                    "Mobile",
                    "Status",
                ],
            ];
            this.getSchema.forEach(item => {
                data.push([
                    item.index,
                    item.code,
                    item.supplier_name,
                    item.s_type,
                    item.s_country,
                    item.supplier_tin,
                    item.supplier_bin,
                    item.supplier_vat,
                    item.supplier_address,
                    item.supplier_email,
                    item.supplier_mobile,
                    item.status == 1 ? "Active" : "Inactive",
                ]);
            });
            this.$exportTableToExcel(data, "supplier_list_report_" + this.$fileDate());
        },
    },
};
</script>
